import {
  Components, ColorProfiles,
} from '@powdr/constants';

// Color Profiles
const {
  BASE, PRIMARY, SECONDARY, TERTIARY, QUATERNARY,
} = ColorProfiles;

export const config = {
  [Components.HEADER]: PRIMARY,
  [Components.MAIN_NAV]: BASE,
  [Components.MEGA_NAV]: BASE,
  [Components.MOBILE_NAV]: BASE,
  [Components.ECOMMERCE_BANNER]: SECONDARY,
  [Components.WEATHER_FEED]: SECONDARY,
  [Components.PROMOTIONS_FEED]: TERTIARY,
  [Components.PROMOTIONS]: PRIMARY,
  [Components.ALERT_BAR]: QUATERNARY,
  [Components.STICKY_NAV]: SECONDARY,
  [Components.TERTIARY_NAV]: BASE,
  [Components.LEVELS_MODAL]: BASE,
  [Components.FOOTER]: SECONDARY,
  [Components.PARTNERS]: SECONDARY,
  [Components.COPYRIGHT]: PRIMARY,
  [Components.MODAL]: BASE,
  [Components.TV]: PRIMARY,
  [Components.DOR]: BASE,
  layout: {
    headerHeight: 75,
    headerHeightMobile: 60,
    headerLogoContainerWidth: 320,
    headerFeedContainer: 280,
  },
};
